import { useSignIn } from 'react-auth-kit';
import { useNavigate } from 'react-router-dom';

export default function useCustomSignin(data, redirectUrl) {
  const signIn = useSignIn();
  const navigate = useNavigate();

  function handleSignin(data, redirectUrl) {
    if (data && redirectUrl) {
      console.log('🚀 ~ file: useCunstomSigin.js:10 ~ handleSignin ~ data:', data);

      const res = signIn({
        token: data?.access_token,
        refreshToken: data?.refresh_token,
        expiresIn: Math.floor(data?.jwtExpiration / 60000),
        refreshTokenExpireIn: Math.floor(data?.refreshExpiration / 60000),
        tokenType: 'Bearer',
        authState: {
          user: {
            id: data?.user?.id,
            userId: data?.user?.userId,
            firstName: data?.user?.firstName,
            lastName: data?.user?.lastName,
            mail: data?.user?.mail,
            phone: data?.user?.phone,
            myEnterpriseNiu: data?.user?.myEnterpriseNiu,
            roles: data?.user?.roles,
          },
        },
        // Only if you are using refreshToken feature
      });
      if (res) {
        navigate(redirectUrl);
      }
    }
  }
  return handleSignin;
}
